module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/16shFWQ/tc-custom/FC-9781645367987.png?1684515369650?1725650027065",
      "alt": "This image is the cover for the book The Wondrous Apothecary"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Wondrous Apothecary\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Follow the paths of two artists, Alexander Wainwright and Rinaldo, in a passionate, suspenseful tale of art, life, love, and liberation. For such different men in their art and personalities, the fundamental question is whether they can ever collaborate on a project.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Mary E. Martin\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }), _c('p', {
    staticStyle: {
      "margin-top": "0mm",
      "margin-right": "0mm",
      "margin-bottom": ".0001pt",
      "margin-left": "0mm",
      "font-size": "15px",
      "font-family": "\"Calibri\",\"sans-serif\"",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "15px",
      "font-family": "\"Times New Roman\",\"serif\""
    }
  }, [_vm._v("After thirty years of law practice, Mary E. Martin embarked on her writing career. Inspired by her experiences in the law, she wrote the highly acclaimed "), _c('em', [_vm._v("Osgoode Trilogy")]), _vm._v(" about a lawyer named Harry Jenkins. Turning to her greatest passion, art, she then began "), _c('em', [_vm._v("The Trilogy of Remembrance,")]), _vm._v(" featuring a visionary landscape artist, Alexander Wainwright. "), _c('em', [_vm._v("The Wondrous Apothecary")]), _vm._v(" is a natural and exciting addition to that trilogy. She lives in Toronto with her husband. They have three children and three grandchildren.")])]), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0